<template>
    <select ref="selectElement" class="js-example-placeholder-multiple js-states form-control" multiple="multiple" style="width: 100%">
        <option v-for="(item, index) in customOptions" :key="index" :value="item">
            {{ item }}
        </option>
    </select>
</template>
  
  <script>
import $ from 'jquery';
export default {
    props: ['disable', 'label', 'model', 'value', 'options', 'error', 'rules'],
    mounted() {
        this.input = this.value;
        this.customOptions = this.options;
        this.filteredOptions = this.customOptions;
        this.initSelect2();
        $(this.$refs.selectElement).on('change', this.handleSelectChange);
    },
    beforeDestroy() {
        $(this.$refs.selectElement).select2('destroy');
    },
    data() {
        return {
            input: '',
            filteredOptions: [],
            customOptions: [],
        };
    },
    methods: {
        handleSelectChange() {
            let dataList = $(this.$refs.selectElement).val();
            let findOfClear = dataList.some((data) => data === 'Clear');
            let findOfAll = dataList.some((data) => data === 'All');
            if (findOfClear) {
                $(this.$refs.selectElement).val(null).trigger('change');
            }
            if (findOfAll) {
                let finalData = this.customOptions.filter((data) => data !== 'Clear' && data !== 'All');
                $(this.$refs.selectElement).val(finalData).trigger('change');
            }
            this.$emit('change', this.model, $(this.$refs.selectElement).val());
        },
       clearWithFormData() {
  $(this.$refs.selectElement)
    .val(null)
    .trigger('change');

  // Tell parent the value is now empty
  this.$emit('input', []);
  this.$emit('change', this.model, []);
},
setWithFormData(values = []) {
  $(this.$refs.selectElement)
    .val(values)
    .trigger('change');

  this.$emit('input', values);
  this.$emit('change', this.model, values);
},


        initSelect2() {
            // Initialize select2 on your select element
            $(this.$refs.selectElement).select2({
                placeholder: this.label,
            });
        },
    },
    watch: {
        options: function () {
            this.customOptions = this.options;
        },
        value: function () {
            this.input = this.value;
        },
    },
};
</script>
  
  <style lang="scss">
@import '../../styles/quasar.variables.scss';
.select2-selection,
.select2-selection--multiple {
    min-height: 40px !important;
    max-height: 80px !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    background-color: rgb(244, 244, 244) !important;

}
.select2-container--default .select2-selection--multiple{
  border: 1px solid $primary !important;
}
.select2-container--default.select2-container--focus .select2-selection--multiple {
        border: 2px solid $primary !important;
    }
</style>
  